import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Menu extends Component {
	render() {
		return (
		<div className="Menu">
			<a href="/engorath/"><div className="MenuItem"><FontAwesomeIcon icon="map"/> Carte</div></a>
			<a href="/engorath/personnages"><div className="MenuItem"><FontAwesomeIcon icon="users"/> Personnages</div></a>
			<a href="/engorath/boite"><div className="MenuItem"><FontAwesomeIcon icon="box-open"/> Boite à Brol</div></a>
			<a href="/engorath/chezjoe"><div className="MenuItem"><FontAwesomeIcon icon="shopping-cart"/> Chez Joe</div></a>
			<a href="/engorath/rumeurs"><div className="MenuItem"><FontAwesomeIcon icon="question"/> Rumeurs</div></a>
			<a href="/engorath/historique"><div className="MenuItem"><FontAwesomeIcon icon="calendar"/> Historique</div></a>
			<a href="/engorath/univers"><div className="MenuItem"><FontAwesomeIcon icon="globe-asia"/> Univers</div></a>
			<a href="https://discord.gg/gKqMSkm" target="_blank"><div className="MenuItem"><FontAwesomeIcon icon="comments"/> Discord</div></a>
		</div>
		);
	}
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js